import AppBarh from "../components/AppBarh";
import Footer from "../components/Footer";
import { Box, Typography } from "@mui/material";
import * as React from "react";

const Privacy = () => {

 const wrapper: React.CSSProperties = {
    maxWidth: "900px",
    margin: "40px auto",
    padding: "30px",
    backgroundColor: "#ffffff",
    border: "1px solid #ddd",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    color: "#333",
  };

  const title: React.CSSProperties = {
    fontSize: "22px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "30px",
    color: "#1a202c",
  };

  const heading: React.CSSProperties = {
    fontSize: "16px",
    fontWeight: 600,
    marginTop: "30px",
    marginBottom: "10px",
    color: "#2d3748",
  };

  const paragraph: React.CSSProperties = {
    fontSize: "14px",
    lineHeight: "1.7",
    marginBottom: "20px",
    textAlign: "justify",
  };

  const list: React.CSSProperties = {
    paddingLeft: "20px",
    fontSize: "14px",
    marginBottom: "20px",
  };

  const listItem: React.CSSProperties = {
    marginBottom: "8px",
  };

  const email: React.CSSProperties = {
    color: "#0073e6",
    textDecoration: "none",
  };

  return (

    <div className="Example">
      <AppBarh/>

<div style={wrapper}>
      <h1 style={title}>Privacy Policy</h1>

      <p style={paragraph}>
        The Uva Wellassa University Alumni Association is committed to protecting the privacy of its members, supporters, and stakeholders. This policy outlines how we collect, use, store, and protect personal information.
      </p>

      <h2 style={heading}>Information We Collect:</h2>
      <ul style={list}>
              <li style={listItem}>Full Name, Profile Image, Contact Information (email, phone number, address)</li>
              <li style={listItem}>Academic and Professional Information</li>
              <li style={listItem}>Payment Details (when applicable)</li>
            </ul>

      <h2 style={heading}>How We Use Your Information:</h2>

      <ul style={list}>
        <li style={listItem}>To maintain an accurate alumni database</li>
        <li style={listItem}>To communicate about events, activities, and initiatives</li>
        <li style={listItem}>To process membership, donations, and event registrations</li>
        <li style={listItem}>To improve our services and outreach</li>
      </ul>

      <h2 style={heading}>Data Protection:</h2>

      <p style={paragraph}>
         We implement appropriate security measures to protect personal data from unauthorized access, alteration, disclosure, or destruction. Information is only accessed by authorized personnel.
      </p>

       <h2 style={heading}>Sharing of Information:</h2>

            <p style={paragraph}>
               We do not sell or share your personal information with third parties for marketing purposes. Your data may only be shared:
            </p>

                  <ul style={list}>
                    <li style={listItem}>With your consent</li>
                    <li style={listItem}>When required by law</li>
                    <li style={listItem}>With trusted service providers for administrative purposes (e.g., email communication platforms)</li>
                  </ul>

      <h2 style={heading}>Your Rights:</h2>

      <p style={paragraph}>
         You have the right to access, correct, or request deletion of your personal data. Please contact us at {" "}
         <a href="mailto:alumni@std.uwu.ac.lk" style={email}> alumni@std.uwu.ac.lk </a>{" "} for any queries or concerns.
      </p>

    </div>

      <Footer/>
    </div>

  );
};

export default Privacy;